<template>
  <div class="categories">
    <!-- 标题栏 -->
    <!-- <van-nav-bar left-arrow title="分类页面" @click-left="onClickLeft" /> -->
    <!-- 内容 -->
    <div class="page">
      <div class="container">
        <div
          class="kqb-section"
          v-for="(item, index) in Categories"
          
          @click="[item.goodsCategoryNameEn == 'all'? ''
                              : pageJump('/subcategories', item)] " 
          :key="index"
        >
          <div class="content">
            <span class="title">{{ item.goodsCategoryName }}</span>
            <img src="img/index/narr.png" class="icon_nav" />
            <!-- <span class="icon_nav">></span> -->
          </div>
        </div>
        <!--最后一个是站位用的，不能删掉-->
        <div class="kqb-section" style="background-color: transparent">
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "categories",
  data() {
    return {
      message: "",
      goodsCategoryList: [],
      Categories:[],  //一级分类
      storeId:''
    };
  },
  created() {
    // this.getGoosCategory();
    let storeId = sessionStorage.getItem("storeId");
    this.storeId = storeId;
    this.getAllCategories();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    // 页面跳转
    pageJump(uri, item) {
      const thisObj = this;
      let queryData = {
        goodsCategoryName: item.goodsCategoryName,
        goodsCategoryId: item.goodsCategoryId,
      };
      thisObj.$router.push({
        path: uri,
        query: queryData,
      });
    },
    pageJumpSelf(uri){
      //全部分类重定向
      const thisObj = this;
      thisObj.$router.push({
        path:uri
      })
    },
    getGoosCategory() {
      var thisObj = this;
      //   var storeId = this.$root.userInfo.storeId
      var storeId = "STOREINFOFBCB01621A0AFE62F036E8C9D0B01BCD#";
      thisObj.$api
        .get(
          thisObj.requestUrl +
            "/knowledge/goods/category/getKnowledgeGoodsCategory?fromDevice=h5&storeId=" +
            storeId,
          {}
        )
        .then((res) => {
          console.log(res);
          if (res.resultCode === 200 && res.success) {
            thisObj.goodsCategoryList = res.resultData;
          } else {
            thisObj.$util.requetServerError(res.resultMsg);
          }
        })
        .catch(function (error) {
          thisObj.$util.requetServerError(error);
        });
    },
    //获取一级分类
    getAllCategories(){
      const that = this;
      console.log("getAllCategories ")
      that.$api
        .get(
          that.requestUrl+
          "/knowledge/goods/getAllCategories?fromDevice=h5&storeId=" +
            this.storeId,
          {}
        )
        .then((res) => {
          if(res.resultCode === 200 && res.success){
              that.Categories = res.resultData; 
              for(let i = 0;i<that.Categories.length;i++){
                if(that.Categories[i].goodsCategoryNameEn == 'all'){
                  console.log(i)
                  console.log(that.Categories[i].goodsCategoryNameEn)
                  that.Categories.splice(i,1);
                }
              }
          }else{
            console.log("未成功获取数据")
          }
        })
    },
  },
};
</script>

<style scoped>
/* .app {
  background-color: #eae8e8;
  height: 1200px;
} */
 html,body,#app{
    background-color: #eae8e8;
  }
  .page{
    background-color: #eae8e8;
  }
.categories{
  background-color: #eae8e8; 
  height: auto;
  width: auto; 
}
.van-nav-bar {
  background-color: #dd405e;
}
.container {
  top: 20px;
  background-color: #eae8e8; 
}

.icon_nav {
  position: absolute;
  left: 0.21333rem;
  top: 50%;
  left: 142%;
  width: 60px;
  height: 60px;
  transform: translate(0, -50%);
}
.content {
  width: 40%;
}
.kqb-section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  width: 95%;
  height: 108px;
  margin: 20px 20px;
  border-radius: 30px;
  background-color: #acd598;
  opacity: 0.7;
}
.title {
  font-size: 45px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #010101;
}
</style>
